import { Role } from "../consts/roles.consts"
import { ADMIN_ROUTES } from "../routers/roleRoutes/adminRoutes.routes"
import { ADMIN_WITHOUT_REPORT_ROUTES } from "../routers/roleRoutes/adminWithoutReportRoutes.routes"
import { TEAM_LEADER_ROUTES } from "../routers/roleRoutes/teamLeaderRoutes.routes"
import { TEAM_MEMBER_ROUTES } from "../routers/roleRoutes/teamMemberRoutes.routes"

const RoutesByRole = {
  [Role.ADMIN]: ADMIN_ROUTES,
  [Role.ADMIN_WITHOUT_REPORT]: ADMIN_WITHOUT_REPORT_ROUTES,
  [Role.TEAM_LEADER]: TEAM_LEADER_ROUTES,
  [Role.TEAM_MEMBER]: TEAM_MEMBER_ROUTES,
}

/**
 *
 * @param {string} role
 */
export function getRoutesByRole(role) {
  return RoutesByRole[role] || []
}

export function getRouteIfAllowedEnvironment(routeObj, environments) {
  if (environments.includes(process.env.REACT_APP_ENVIROMENT)) {
    return [routeObj]
  }
  return []
}

export function getRoutesIfAllowedEnvironment(routeObjArray, environments) {
  if (environments.includes(process.env.REACT_APP_ENVIROMENT)) {
    return routeObjArray
  }
  return []
}
